import { addDoc, collection, getDocs, limit, orderBy, query, serverTimestamp, startAfter, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

export const ADMIN_LOGS_COLLECTION = "adminlogs";

// Chaves de ação registradas hoje — todas de gestão de usuário (findUser.tsx e createUser.tsx).
// Ao registrar uma ação nova, adicione a chave aqui e o rótulo em adminLogActionFields (utils/fields.ts).
export type AdminLogAction =
    | "role.admin.grant"
    | "role.admin.revoke"
    | "role.advertiser.grant"
    | "role.advertiser.revoke"
    | "verify.email"
    | "verify.phone"
    | "user.create";

export interface IAdminLog {
    id: string;
    action: AdminLogAction | string;
    actorId: string | null;
    actorName: string | null;
    actorEmail: string | null;
    targetId: string | null;
    targetName: string | null;
    targetEmail: string | null;
    details: string | null;
    createdAt: Timestamp | null;
}

interface ILogParams {
    action: AdminLogAction;
    actorId: string | null;
    actorName?: string | null;
    actorEmail?: string | null;
    targetId: string | null;
    targetName?: string | null;
    targetEmail?: string | null;
    details?: string | null;
}

// Grava um registro de auditoria. NUNCA lança: uma falha ao logar não pode
// desfazer nem bloquear a operação de admin que já foi aplicada no banco.
export async function logAdminAction(params: ILogParams) {
    try {
        await addDoc(collection(db, ADMIN_LOGS_COLLECTION), {
            action: params.action,
            actorId: params.actorId || null,
            actorName: params.actorName || null,
            actorEmail: params.actorEmail || null,
            targetId: params.targetId || null,
            targetName: params.targetName || null,
            targetEmail: params.targetEmail || null,
            details: params.details || null,
            createdAt: serverTimestamp()
        });
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}

// Página de logs mais recentes primeiro. `after` é o createdAt do último item já
// carregado, usado pelo "Carregar mais" da tela de logs.
export async function getAdminLogs(pageSize: number, after?: Timestamp | null) {
    try {
        const col = collection(db, ADMIN_LOGS_COLLECTION);
        const q = after
            ? query(col, orderBy("createdAt", "desc"), startAfter(after), limit(pageSize))
            : query(col, orderBy("createdAt", "desc"), limit(pageSize));
        const documents = await getDocs(q);
        const logs: IAdminLog[] = documents.docs.map(document => {
            const data = document.data();
            return {
                id: document.id,
                action: data.action,
                actorId: data.actorId ?? null,
                actorName: data.actorName ?? null,
                actorEmail: data.actorEmail ?? null,
                targetId: data.targetId ?? null,
                targetName: data.targetName ?? null,
                targetEmail: data.targetEmail ?? null,
                details: data.details ?? null,
                createdAt: data.createdAt ?? null
            };
        });
        return logs;
    } catch (error) {
        console.log(error);
        return null;
    }
}
